<div class="quote-container">
	<h3 class="quote-text">"{{quoteText}}"</h3>
	<div class="source-title-container">
	<div class="quote-source">{{quoteSource}}</div>
	<div class="quote-title">{{quoteTitle}}</div>
	</div>
</div>
